// extracted by mini-css-extract-plugin
module.exports = {"image":"Image_image__4HGeB","animated":"Image_animated__56Hn_","isCover":"Image_isCover__i4p6_"};